import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { MenuRoute, SideNavigation } from '@thirdspacelearning/library';

import { menuRoutes } from '@routes';

import { setOpen, navSelector } from '@store/navigation';

const SideMenu = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const { open } = useSelector(navSelector);

    const updateRoute = (item: MenuRoute) => {
        navigate(item.key);
    };

    return (
        <SideNavigation
            routesInfo={menuRoutes}
            open={open}
            onToggleOpen={(open: boolean) => {
                dispatch(setOpen(open));
            }}
            selectedKey={location.pathname}
            onSelectItem={updateRoute}
        />
    );
};

export default SideMenu;
